import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { Quote, Star, ChevronLeft, ChevronRight } from 'lucide-react';
export function TestimonialsCarousel() {
  const {
    language
  } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const content = {
    en: {
      label: 'WHAT CLIENTS SAY',
      headline: 'They Trusted Their Story To KRLY GOLD',
      testimonials: [{
        quote: 'I came with just a vague idea and left with a masterpiece on my skin. The level of detail and realism is something I have never seen before. KRLY is not just a tattoo artist. He is a fine artist.',
        author: 'Maria R., Miami'
      }, {
        quote: 'The consultation alone was worth it. He actually listened to my story and turned it into something deeply personal and incredibly beautiful.',
        author: 'Carlos M., Miami'
      }, {
        quote: 'I have been collecting tattoos for years. This is the first time I feel like I have real fine art on my body. The precision and shading are on another level entirely.',
        author: 'Jennifer L., Miami'
      }, {
        quote: 'As someone who works in the art world I can say with confidence that KRLY approaches tattooing exactly the way a painter approaches a canvas. Truly exceptional work.',
        author: 'Sofia V., Miami'
      }, {
        quote: 'I was nervous about committing to something permanent. KRLY made the entire process feel safe, intentional and deeply artistic. I could not be happier.',
        author: 'Miguel A., Miami'
      }]
    },
    es: {
      label: 'LO QUE DICEN LOS CLIENTES',
      headline: 'Ellos Confiaron Su Historia A KRLY GOLD',
      testimonials: [{
        quote: 'Llegué con una idea vaga y me fui con una obra maestra en la piel. El nivel de detalle y realismo es algo que nunca había visto. KRLY no es solo un tatuador. Es un artista.',
        author: 'Maria R., Miami'
      }, {
        quote: 'Solo la consulta ya valió la pena. Realmente escuchó mi historia y la convirtió en algo profundamente personal e increíblemente hermoso.',
        author: 'Carlos M., Miami'
      }, {
        quote: 'Llevo años coleccionando tatuajes. Es la primera vez que siento que tengo arte real en mi cuerpo. La precisión y el sombreado están en otro nivel.',
        author: 'Jennifer L., Miami'
      }, {
        quote: 'Como alguien que trabaja en el mundo del arte puedo decir con confianza que KRLY aborda el tatuaje exactamente como un pintor aborda un lienzo. Excepcional.',
        author: 'Sofia V., Miami'
      }, {
        quote: 'Estaba nervioso de comprometerme con algo permanente. KRLY hizo que todo el proceso se sintiera seguro, intencional y profundamente artístico. No podría estar más feliz.',
        author: 'Miguel A., Miami'
      }]
    }
  };
  const t = content[language];
  useEffect(() => {
    if (!isHovered) {
      const timer = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % t.testimonials.length);
      }, 4000);
      return () => clearInterval(timer);
    }
  }, [isHovered, t.testimonials.length]);
  const nextSlide = () => setCurrentIndex(prev => (prev + 1) % t.testimonials.length);
  const prevSlide = () => setCurrentIndex(prev => prev === 0 ? t.testimonials.length - 1 : prev - 1);
  return <section className="py-24 md:py-32 px-6 border-b border-brand-gold/30" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <motion.div className="mb-16 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-172">
          <span className="text-brand-gold font-sans text-sm tracking-[0.3em] uppercase block mb-4" data-id="element-173">
            {t.label}
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-brand-gold" data-id="element-174">
            {'Ellos Confiaron Su Historia a KRLY GOLD TATTOO'}
          </h2>
        </motion.div>

        <div className="relative" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-175">
          <div className="bg-brand-charcoal border-t-[3px] border-brand-gold p-8 md:p-12 relative min-h-[350px] md:min-h-[300px] flex flex-col justify-center" data-id="element-176">
            <Quote className="absolute top-6 left-6 w-12 h-12 text-brand-gold/20 rotate-180" data-id="element-177" />

            <AnimatePresence mode="wait" data-id="element-178">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.5
            }} className="relative z-10 text-center" data-id="element-179">
                <div className="flex justify-center gap-1 mb-6" data-id="element-180">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-181" />)}
                </div>

                <p className="text-xl md:text-2xl font-serif text-brand-white leading-relaxed italic mb-8" data-id="element-182">
                  "{t.testimonials[currentIndex].quote}"
                </p>

                <p className="text-brand-gold font-sans text-sm tracking-widest uppercase" data-id="element-183">
                  — {t.testimonials[currentIndex].author}
                </p>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Navigation Controls */}
          <div className="flex items-center justify-center gap-6 mt-8" data-id="element-184">
            <button onClick={prevSlide} className="p-2 text-brand-gold hover:text-brand-white transition-colors" data-id="element-185">
              <ChevronLeft className="w-6 h-6" data-id="element-186" />
            </button>

            <div className="flex gap-2" data-id="element-187">
              {t.testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2 h-2 rounded-full transition-all duration-300 ${currentIndex === idx ? 'bg-brand-gold w-6' : 'bg-brand-gold/30'}`} data-id="element-188" />)}
            </div>

            <button onClick={nextSlide} className="p-2 text-brand-gold hover:text-brand-white transition-colors" data-id="element-189">
              <ChevronRight className="w-6 h-6" data-id="element-190" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}